import React from "react";
import PropTypes from "prop-types";

const DocumentHubViewTab = ({ fileUrl }) => {
  return (
    <div>
      <iframe src={fileUrl} style={{ width: "100%", height: "500px" }}></iframe>
    </div>
  );
};

DocumentHubViewTab.propTypes = {
  fileUrl: PropTypes.string
};

export default DocumentHubViewTab;
